import type { AppRole } from '@/shared/roles/role';

type ResolveRoleParams = {
  queryRole?: string | null;
  startParamRole?: string | null;
  fallbackRole: AppRole;
};

const AVAILABLE_ROLES = new Set<AppRole>(['client', 'manager', 'specialist']);

export function resolveRole({
  queryRole,
  startParamRole,
  fallbackRole,
}: ResolveRoleParams): AppRole {
  if (queryRole && AVAILABLE_ROLES.has(queryRole as AppRole)) {
    return queryRole as AppRole;
  }

  if (startParamRole && AVAILABLE_ROLES.has(startParamRole as AppRole)) {
    return startParamRole as AppRole;
  }

  return fallbackRole;
}
